// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AboutWelcome Component Styles */
.about-welcome {
  padding: 80px 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  position: relative;
  /* Background will be set via inline styles */
}

/* Background Image Variant */
.about-welcome--with-bg {
  min-height: 100vh;
}

/* Fallback background when no image */
.about-welcome--no-bg {
  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);
}

.about-welcome__overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
}

.about-welcome__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
}

.about-welcome__header {
  text-align: center;
  margin-bottom: 4rem;
}

.about-welcome__title {
  font-size: 3rem;
  font-weight: 300;
  letter-spacing: 3px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  background: linear-gradient(135deg, #4A90E2 0%, #357abd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  transition: all 0.3s ease;
}

/* Title with background image */
.about-welcome--with-bg .about-welcome__title {
  background: none;
  -webkit-background-clip: unset;
  background-clip: unset;
  -webkit-text-fill-color: unset;
  color: white !important;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
  font-size: 3.5rem;
}

.about-welcome--with-bg .about-welcome__decorative {
  color: white !important;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7);
}

.about-welcome__decorative {
  font-size: 1.5rem;
  font-weight: 300;
  letter-spacing: 8px;
  opacity: 0.7;
  margin-bottom: 2rem;
}

.about-welcome__content {
  max-width: 900px;
  margin: 0 auto;
}

.about-welcome__content-wrapper {
  transition: all 0.3s ease;
}

.about-welcome__content-wrapper--with-bg {
  padding: 3rem;
  border-radius: 16px;
  backdrop-filter: blur(10px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-top: 2rem;
}

.about-welcome__subtitle {
  font-size: 2rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 3rem;
  color: #4A90E2;
  position: relative;
  padding-bottom: 1rem;
}

.about-welcome__subtitle::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #4A90E2, transparent);
}

.about-welcome__text {
  line-height: 1.8;
  font-size: 1.1rem;
  color: #555;
}

.about-welcome__paragraph {
  margin-bottom: 1.8rem;
  text-align: justify;
  position: relative;
  padding-left: 1rem;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
}

.about-welcome__paragraph::before {
  content: '';
  position: absolute;
  left: -3px;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, #4A90E2, #87ceeb);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.about-welcome__paragraph:hover::before {
  opacity: 1;
}

.about-welcome__paragraph:first-child {
  font-size: 1.15rem;
  font-weight: 500;
  color: #333;
}

.about-welcome__paragraph:last-child {
  font-style: italic;
  color: #4A90E2;
  font-weight: 500;
  text-align: center;
  padding-left: 0;
  border-left: none;
  margin-top: 2.5rem;
  font-size: 1.1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .about-welcome {
    padding: 60px 0;
  }
  
  .about-welcome__container {
    padding: 0 1.5rem;
  }
  
  .about-welcome__title {
    font-size: 2.2rem;
    letter-spacing: 2px;
  }
  
  .about-welcome__subtitle {
    font-size: 1.6rem;
  }
  
  .about-welcome__text {
    font-size: 1rem;
  }
  
  .about-welcome__paragraph {
    text-align: left;
    padding-left: 0.5rem;
  }
}

@media (max-width: 480px) {
  .about-welcome__title {
    font-size: 1.8rem;
    letter-spacing: 1px;
  }
  
  .about-welcome__subtitle {
    font-size: 1.4rem;
  }
  
  .about-welcome__decorative {
    letter-spacing: 4px;
  }
  
  .about-welcome--with-bg .about-welcome__title {
    font-size: 1.8rem;
  }
  
  .about-welcome__content-wrapper--with-bg {
    padding: 1.5rem;
    margin-top: 1rem;
  }
}

/* Additional responsive styles for background image variant */
@media (max-width: 768px) {
  .about-welcome--with-bg {
    min-height: 80vh;
    background-attachment: scroll;
  }
  
  .about-welcome--with-bg .about-welcome__title {
    font-size: 2.2rem;
  }
  
  .about-welcome__content-wrapper--with-bg {
    padding: 2rem;
    margin-top: 1.5rem;
  }
}

@media (max-width: 480px) {
  .about-welcome--with-bg {
    min-height: 70vh;
  }
  
  .about-welcome--with-bg .about-welcome__title {
    font-size: 1.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AboutWelcome.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,qEAAqE;AACvE;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,qDAAqD;EACrD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* AboutWelcome Component Styles */\n.about-welcome {\n  padding: 80px 0;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  /* Background will be set via inline styles */\n}\n\n/* Background Image Variant */\n.about-welcome--with-bg {\n  min-height: 100vh;\n}\n\n/* Fallback background when no image */\n.about-welcome--no-bg {\n  background: linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%);\n}\n\n.about-welcome__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 1;\n}\n\n.about-welcome__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  position: relative;\n  z-index: 2;\n}\n\n.about-welcome__header {\n  text-align: center;\n  margin-bottom: 4rem;\n}\n\n.about-welcome__title {\n  font-size: 3rem;\n  font-weight: 300;\n  letter-spacing: 3px;\n  margin-bottom: 1.5rem;\n  text-transform: uppercase;\n  background: linear-gradient(135deg, #4A90E2 0%, #357abd 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  transition: all 0.3s ease;\n}\n\n/* Title with background image */\n.about-welcome--with-bg .about-welcome__title {\n  background: none;\n  -webkit-background-clip: unset;\n  background-clip: unset;\n  -webkit-text-fill-color: unset;\n  color: white !important;\n  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);\n  font-size: 3.5rem;\n}\n\n.about-welcome--with-bg .about-welcome__decorative {\n  color: white !important;\n  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7);\n}\n\n.about-welcome__decorative {\n  font-size: 1.5rem;\n  font-weight: 300;\n  letter-spacing: 8px;\n  opacity: 0.7;\n  margin-bottom: 2rem;\n}\n\n.about-welcome__content {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.about-welcome__content-wrapper {\n  transition: all 0.3s ease;\n}\n\n.about-welcome__content-wrapper--with-bg {\n  padding: 3rem;\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  margin-top: 2rem;\n}\n\n.about-welcome__subtitle {\n  font-size: 2rem;\n  font-weight: 400;\n  text-align: center;\n  margin-bottom: 3rem;\n  color: #4A90E2;\n  position: relative;\n  padding-bottom: 1rem;\n}\n\n.about-welcome__subtitle::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, #4A90E2, transparent);\n}\n\n.about-welcome__text {\n  line-height: 1.8;\n  font-size: 1.1rem;\n  color: #555;\n}\n\n.about-welcome__paragraph {\n  margin-bottom: 1.8rem;\n  text-align: justify;\n  position: relative;\n  padding-left: 1rem;\n  border-left: 3px solid transparent;\n  transition: all 0.3s ease;\n}\n\n.about-welcome__paragraph::before {\n  content: '';\n  position: absolute;\n  left: -3px;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: linear-gradient(180deg, #4A90E2, #87ceeb);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.about-welcome__paragraph:hover::before {\n  opacity: 1;\n}\n\n.about-welcome__paragraph:first-child {\n  font-size: 1.15rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.about-welcome__paragraph:last-child {\n  font-style: italic;\n  color: #4A90E2;\n  font-weight: 500;\n  text-align: center;\n  padding-left: 0;\n  border-left: none;\n  margin-top: 2.5rem;\n  font-size: 1.1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .about-welcome {\n    padding: 60px 0;\n  }\n  \n  .about-welcome__container {\n    padding: 0 1.5rem;\n  }\n  \n  .about-welcome__title {\n    font-size: 2.2rem;\n    letter-spacing: 2px;\n  }\n  \n  .about-welcome__subtitle {\n    font-size: 1.6rem;\n  }\n  \n  .about-welcome__text {\n    font-size: 1rem;\n  }\n  \n  .about-welcome__paragraph {\n    text-align: left;\n    padding-left: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-welcome__title {\n    font-size: 1.8rem;\n    letter-spacing: 1px;\n  }\n  \n  .about-welcome__subtitle {\n    font-size: 1.4rem;\n  }\n  \n  .about-welcome__decorative {\n    letter-spacing: 4px;\n  }\n  \n  .about-welcome--with-bg .about-welcome__title {\n    font-size: 1.8rem;\n  }\n  \n  .about-welcome__content-wrapper--with-bg {\n    padding: 1.5rem;\n    margin-top: 1rem;\n  }\n}\n\n/* Additional responsive styles for background image variant */\n@media (max-width: 768px) {\n  .about-welcome--with-bg {\n    min-height: 80vh;\n    background-attachment: scroll;\n  }\n  \n  .about-welcome--with-bg .about-welcome__title {\n    font-size: 2.2rem;\n  }\n  \n  .about-welcome__content-wrapper--with-bg {\n    padding: 2rem;\n    margin-top: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-welcome--with-bg {\n    min-height: 70vh;\n  }\n  \n  .about-welcome--with-bg .about-welcome__title {\n    font-size: 1.6rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
